import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../../lib/utils';
import { theme } from '../../theme';

const tagVariants = cva(
  'inline-flex items-center justify-center cursor-pointer max-w-full min-w-0 font-sora font-normal text-black max-w-[200px] bg-secondary-50',
  {
    variants: {
      size: {
        md: 'px-3 py-1 h-8 text-[14px] leading-[17.6px] rounded-lg',
        sm: 'min-w-6 px-1 py-0.5 h-6 text-sm rounded-sm',
      },
      site: {
        porta: '',
        portaNZ: '',
        redRec: 'bg-primary-100 text-primary',
      },
    },
    defaultVariants: {
      size: 'md',
      site: 'porta',
    },
  },
);

export interface TagProps extends VariantProps<typeof tagVariants> {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export function Tag({ children, onClick, className, size }: TagProps) {
  return (
    <div className={cn(tagVariants({ size, site: theme }), className)} role={onClick ? 'button' : undefined}>
      <span className="truncate max-w-full block">{children}</span>
    </div>
  );
}
